module.exports = __webpack_public_path__ + "static/img/pexels-photo-60626.616663d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sources/pexels-photo-60626.jpeg
// module id = NU6d
// module chunks = 1